import React, { useEffect, useState } from "react";
import {
  Box,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Paper,
  Select,
  Typography,
  useTheme,
} from "@mui/material";
import { useStyles } from "../../style";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { AGGREGATIONDATALISTAPI } from "utility/constants";
import HistogramIcon from "assets/histogramIcon";
import PieChart from "shared-component/pie-chart";

dayjs.extend(utc);

interface HeatMapVisualizationPropTypes {
  userInputData: string[];
  updatePieChartFilter: (value: any) => void;
  aggregateType?: any;
  signalList: any;
  groupBy: any;
  setSelectedVinListVisualization: (value: any) => void;
}


const MenuProps = {
  PaperProps: {
    style: {
      width: 250,
    },
  },
};

const PieChartVisualization = (props: HeatMapVisualizationPropTypes) => {
  const style = useStyles();
  const theme = useTheme();
  const [pieChartData, setPieChartData] = useState<any>(null);
  const [filterList] = useState<any>();
  const [filterName] = useState<string>();
  const [filterSelected, setFilterSelected] = useState<any>([]);
  const cDadDataVisualizationData: any = {}

  const updateBarChartFilterData = () => {
    let data: any;
    let layout: any;
    let filtElement: string[];
    let pieChartDataValue: any[] = [];
    let axisData: any[] = [];
    let axisvalue: any = [];
    let hoverYAxisText: string[] = [];
    if (props.signalList?.length > 0 && cDadDataVisualizationData?.length > 0) {
      props.signalList?.forEach((elemnt: any) => {
        const currentdata = cDadDataVisualizationData[0][elemnt];
        if (currentdata && currentdata[filterSelected]?.length > 0) {
          currentdata[filterSelected]?.forEach((element: any) => {
            if (element['count']) {
              axisvalue.push(element['count'])
            }
            if (element) {
              const groupData = element;
              filtElement = Object.keys(groupData)?.filter((item: string) => item !== 'count');
               if(filtElement?.length >= 0 && filtElement[0] === 'hour') {
                AGGREGATIONDATALISTAPI.forEach((item: any) => item.value === 'timeofday' ? item.value = 'hour' : item)
               }
              const apiResponseValue = AGGREGATIONDATALISTAPI.filter((item: any) => item.value === filtElement[0]);
              let value: any = null;
              if (groupData[apiResponseValue[0]?.value]) {
                value = groupData[apiResponseValue[0]?.value]
              }
              if (value) {
                if (value?.length > 6) {
                  axisData.push(value?.substring(0, 6))
                } else {
                  axisData.push(value)
                }
                hoverYAxisText.push(value);
              }
            }
          })
        }
      
      })
    }
    data = [
      {
        type: 'pie',
        labels: props.signalList,
        values: axisvalue,
        textinfo: 'label+percent',
        insidetextorientation: 'horizontal',
      }
    ];
    
    layout = {
      width: window.innerWidth > 1350 ? 800 : 850,
      height: window.innerWidth > 1350 ? 500 : 550,
      // Adjust margin to move the heatmap to the top
      margin: {
        t: 50, // Adjust this value as needed
        l: 50,
        r: 50,
        b: 50
      },
      yaxis: {
        automargin: true,
      },
      xaxis: {
        automargin: true,
      },
    }
    pieChartDataValue.push({
      data, layout
    })
    setPieChartData(pieChartDataValue)
  }

  const updateBarChartFilterDataDiscrete = () => {
    let data: any;
    let layout: any;
    let barData: any[] = [];
    if (props.signalList?.length > 0 && cDadDataVisualizationData?.length > 0) {
      props.signalList?.forEach((elemnt: any) => {
        let axisData: any[] = [];
        let axisvalue: any = [];
        let hoverYAxisText: string[] = [];
        const currentdata = cDadDataVisualizationData[0][elemnt]
        if (currentdata[filterSelected]?.length > 0) {
          currentdata[filterSelected]?.forEach((element: any) => {
            if (element['value']) {
              axisvalue.push(element['value'])
            }
            if (element['count']) {
              let value: any = element['count'];
              if (value) {
                axisData.push(value)
                hoverYAxisText.push(value);
              }
            }
          })
        }
        data = [
          {
            x: axisData,
            y: axisvalue,
            type: '',
            orientation: 'h',
            marker: {
              color: '#EB0A1E'
            },
          }
        ];
        layout = {
          title: elemnt,
          width: window.innerWidth > 1350 ? 800 : props.signalList?.length === 1 ? 850 : 425,
          height: window.innerWidth > 1350 ? 500 : props.signalList?.length === 1 ? 550 : 400,
          // Adjust margin to move the heatmap to the top
          margin: {
            t: 50, // Adjust this value as needed
            l: 50,
            r: 50,
            b: 50
          },
          yaxis: {
            automargin: true,
            title: 'Value'
          },
          xaxis: {
            automargin: true,
            title: 'Count'
          },
        }
        barData.push({
          data, layout
        })
      })
    }
    setPieChartData(barData)
  }

  // useEffect(() => {
  //   if (cDadDataVisualizationData?.length > 0) {
  //     setFilterList(cDadDataVisualizationData[0]?.group_list);
  //     setFilterName(cDadDataVisualizationData[0]?.group_name);
  //     setFilterSelected([])
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [cDadDataVisualizationData])

  useEffect(() => {
    if(cDadDataVisualizationData) {
      props?.aggregateType?.length > 0 && props?.aggregateType[0]?.indexOf('discrete') >= 0 ? updateBarChartFilterDataDiscrete() : updateBarChartFilterData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterSelected])

  const filterSelection = () => {
    return (
      <FormControl style={{ width: "35%" }}>
        <InputLabel htmlFor="grouped-native-select">
          {filterName}
        </InputLabel>
        <Select
          id="filterSelect"
          value={filterSelected}
          MenuProps={MenuProps}
          onChange={(event) => {
            const {
              target: { value },
            } = event;
            setFilterSelected(value);
            if (typeof value === 'string') {
              props?.setSelectedVinListVisualization([value]);
            } else if (Array.isArray(value)) {
              props?.setSelectedVinListVisualization(value);
            } else if (typeof value === 'function') {
              props?.setSelectedVinListVisualization(value);
            }
          }}
          input={<OutlinedInput label="Signals" />}
        >
          {filterList?.map(
            (item: any, index: number) => (
              <MenuItem key={index} value={item}>
                <ListItemText primary={item} />
              </MenuItem>
            )
          )}
        </Select>
      </FormControl>
    )
  }
  return (
    <Box bgcolor="white">
      {cDadDataVisualizationData?.isLoading &&
        <div className={style.overlay}>
          <div className={style.loader}></div>
        </div>}
      <>
        <div style={{ display: "flex", flexDirection: "column" }}>
          {cDadDataVisualizationData && props?.signalList ? <Paper
            elevation={2}
            sx={{
              margin: "1%",
              padding: "2%",
              width: "100%",
            }}
          >
            {filterSelection()}
            {(pieChartData && filterSelected?.length === 0) && 
            <Box
              flex={1}
              my={2}
              display={"flex"}
              flexDirection={"column"}
              alignItems={"center"}
            >
              <HistogramIcon />
              <Typography
                variant="caption"
                textAlign={"center"}
                color={theme.palette.text.disabled}
                fontWeight={"bold"}
                width={350}
              >
                Use the VINs from dropdowns to analyse in Pie Chart data chart!
              </Typography>
            </Box>}
            {pieChartData && filterSelected?.length > 0 && <PieChart data={pieChartData[0]} layout={pieChartData[0]?.layout} />}
          </Paper> : null}
          {/* {cDadDataVisualizationData && props?.signalList?.length > 1 && <div style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            rowGap: '1rem',
            columnGap: '1rem',
            padding: '1rem'
          }}>
            {props?.signalList?.length > 1 && props?.signalList?.map((item: any, index: number) => {
              return <Paper
                elevation={2}
                sx={{
                  margin: "1%",
                  padding: "2%",
                  width: "100%",
                }}
              >
            {filterSelection()}
                <PieChart data={barChartData[index]} layout={barChartData[index]?.layout} />
              </Paper>
            })}
          </div>} */}
          {(!pieChartData) && <Paper
            elevation={2}
            sx={{
              margin: "1%",
              padding: "2%",
              width: "100%",
            }}
          >
            <Box
              flex={1}
              my={2}
              display={"flex"}
              flexDirection={"column"}
              alignItems={"center"}
            >
              <HistogramIcon />
              <Typography
                variant="caption"
                textAlign={"center"}
                color={theme.palette.text.disabled}
                fontWeight={"bold"}
                width={350}
              >
                Use the Signal/Channel from dropdowns to analyse in Pie Chart data chart!
              </Typography>
            </Box>
          </Paper>}
        </div>
      </>
    </Box>
  );
};

export default PieChartVisualization;  